import * as React from 'react'

interface ClashIconProps {
    className?: string
    title?: string
}

/**
 * Warning triangle icon for Best Practice clash indicator
 * Follows the same design pattern as other workspace icons (e.g., ThunderboltIcon)
 */
export const ClashIcon: React.FC<ClashIconProps> = ({
    className = '',
    title = 'Best Practice Clash indicator',
}) => {
    return (
        <svg
            width={20}
            height={18}
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            role="img"
            aria-labelledby="clash-icon-title"
            focusable="false"
        >
            <title id="clash-icon-title">{title}</title>
            <path
                d="M10 1.5L18.5 16.5H1.5L10 1.5Z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M10 7V11"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx={10}
                cy={13.5}
                r={0.75}
                fill="currentColor"
            />
        </svg>
    )
}
